/* eslint-disable*/

import { ChevronRight, MoveRight } from 'lucide-react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../Components/ui/tabs'
import MFSips from '../MutualFunds/MFSips'
import BasketSIPs from '../MutualFundsBaskets/BasketSIPs'
import ShowAllMandate from '../Mandates/ShowAllMandate'

const MFsSIPs = () => {
  return (
    <>
      <div className='max-w-[1128px] mx-auto'>
        <h2 className='py-4 px-2 lg:px-0 font-semibold text-black-500 leading-6 tracking-[-4%] flex items-center gap-x-1'>
          My SIPs & Mandates
          <ChevronRight />
        </h2>
      </div>

      <div className='max-w-[1128px] mx-auto'>
        <Tabs defaultValue='Goals' className='relative mr-auto w-full'>
          <TabsList className='justify-start rounded-none border-b bg-transparent p-0'>
            <TabsTrigger
              value='Goals'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Goals
            </TabsTrigger>

            <TabsTrigger
              value='Mutual Funds'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Mutual Funds
            </TabsTrigger>

            <TabsTrigger
              value='Mandates'
              className='relative rounded-none border-b-2 border-b-transparent bg-transparent px-4 pb-3 pt-2 font-semibold text-muted-foreground shadow-none transition-none focus-visible:ring-0 data-[state=active]:border-b-primary data-[state=active]:text-foreground data-[state=active]:shadow-none '
            >
              Mandates
            </TabsTrigger>
          </TabsList>

          <TabsContent value='Goals'>
            <BasketSIPs />
          </TabsContent>

          <TabsContent value='Mutual Funds'>
            <MFSips />
          </TabsContent>

          <TabsContent value='Mandates'>
            <ShowAllMandate />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}

export default MFsSIPs
